import { render, staticRenderFns } from "./CardStep.vue?vue&type=template&id=b06d7b14&scoped=true&"
import script from "./CardStep.vue?vue&type=script&lang=ts&"
export * from "./CardStep.vue?vue&type=script&lang=ts&"
import style0 from "./CardStep.vue?vue&type=style&index=0&id=b06d7b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d7b14",
  null
  
)

export default component.exports